import { render, staticRenderFns } from "./NotificationChannelsTable.vue?vue&type=template&id=1fd968aa&scoped=true&"
import script from "./NotificationChannelsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationChannelsTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationChannelsTable.vue?vue&type=style&index=0&id=1fd968aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd968aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd968aa')) {
      api.createRecord('1fd968aa', component.options)
    } else {
      api.reload('1fd968aa', component.options)
    }
    module.hot.accept("./NotificationChannelsTable.vue?vue&type=template&id=1fd968aa&scoped=true&", function () {
      api.rerender('1fd968aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/NotificationChannelsTable.vue"
export default component.exports